"use client";

import React from "react";
// import { MutableRefObject, useEffect, useRef, useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import SectionHeading from "../shared/SectionHeading";
import "swiper/swiper-bundle.css";
import "swiper/css";

const UniversityDetails = ({ universityData, data }) => {
  const IMAGE_BASE = process.env.REACT_APP_IMAGE_URL;
  // const swiperRef = useRef();

  return (
    <div className="mt-16 mx-auto max-w-[1400px] flex flex-col items-center px-4 sm:px-6 lg:px-8">
      {/* Title Section */}
      <div className="w-full flex items-center justify-center text-center">
        <SectionHeading>
          <span className="text-primary-color">Why</span>{" "}
          <span className="text-secondary-color">{universityData?.name} ?</span>
        </SectionHeading>
      </div>

      {/* Content Section */}
      <div className="my-10 flex  h-full flex-col  md:flex-row  gap-6 md:gap-8 items-center md:items-start md:h-[450px] lg:h-[430px]">
        <div className="relative h-full md:w-2/3 h-full w-full">
          {/* Outer Corner Border */}
          <div className="absolute -top-3 -left-3 w-16 h-16 border-t-4 border-l-4 border-[#f90] rounded-tl-md"></div>

          {/* Main Image */}
          <img
            src={`${IMAGE_BASE}/${universityData?.image}`}
            alt={universityData?.name}
            className="w-full h-full object-cover rounded-md shadow-md"
          />
        </div>
        <div className="h-full flex w-full  flex-col gap-4 justify-between  text-center md:text-left">
          <p className="text-xl text-gray-700 text-justify sm:text-base md:text-lg font-normal">
            {universityData?.about}
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {data.section[8].body.list1.map((item, index) => (
              <div
                key={index}
                className="relative group overflow-hidden rounded-xl shadow-xl cursor-pointer bg-white transform hover:-translate-y-2 transition-transform duration-500 ease-in-out"
              >
                {/* Image Box */}
                <div className="flex justify-center items-center p-6 h-32 md:h-40">
                  <img
                    className="h-16 md:h-20 w-auto object-contain transition-transform duration-700 ease-in-out group-hover:scale-110"
                    src={`${IMAGE_BASE}/${item.image}`}
                    alt={item.text}
                  />
                </div>
                <div className="absolute inset-0 flex items-center justify-center 
                  bg-gradient-to-t from-black/95 via-black/90 to-black/85 
                  opacity-0 group-hover:opacity-100 
                  transition-all duration-300 ease-in-out">
                  <p className="text-white text-xs md:text-sm font-medium px-3 py-1 text-center transform translate-y-2 group-hover:translate-y-0 transition-all duration-300 ease-in-out line-clamp-3">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default UniversityDetails;

